import { mapGetters } from "vuex";
import advCounter from 'src/components/advCounter.vue'
import bannerMain from 'src/components/bannerMain.vue'
import advCarusiel from 'src/components/advCarusiel.vue'

export default {
  components: {
    advCarusiel,
    advCounter,
    bannerMain
  },
  data: () => ({
    isDisabled: false,
    countOne:[2,5,5],
    countTwo:[5,6,1],

    bannerHome:[{
      title: 'УНИКАЛЬНЫЙ СЕРВИС ПО ПОИСКУ <span style="color:#981010">АДВОКАТСКИХ УСЛУГ</span>',
      title2: "Ваши деньги в безопасности<br/>пока адвокат не окажет услугу",
      buttonDescription: 'Подробнее',
      chooserDescription: 'Клиенту',
      forUser: 'Для клиента',
      href: '/work'
    },
    {
      title: 'ТЫСЯЧИ КЛИЕНТОВ ИЩУТ <span style="color:#981010">АДВОКАТСКИЕ УСЛУГИ</span> У НАС НА ПОРТАЛЕ',
      title2: 'Зарегистрируйтесь за 5 минут и начните получать новых клиентов уже сегодня',
      buttonDescription: 'Зарегистрироваться',
      chooserDescription: 'Адвокату',
      forUser: 'Для адвоката',
      href: false
    }, {
      title: 'ЧЕСТНОЕ И ЭФФЕКТИВНОЕ СОТРУДНИЧЕСТВО МЕЖДУ <span style="color:#981010">КЛИЕНТАМИ И АДВОКАТАМИ</span>',
      title2: 'Узнайте подробнее как это работает',
      buttonDescription: 'О сервисе',
      chooserDescription: 'О сервисе',
      forUser: 'Для всех',
      href: '/service'
    }],
    adv:[
      {
      img: '',
      surname:null,
      name :null,
      patronimic:null,

    },{
      img: '',
      surname:null,
      name : null,
      patronimic:null,

    },{
      img: '',
      surname:'',
      name : '',
      patronimic:'',

    }
  ],
    article:[
      {
        title: 'Как выбрать надежного адвоката?',
        text: 'Деятельность всех адвокатов строго регламентируется Федеральным законом «Об адвокатской деятельности и адвокатуре в Российской Федерации» (N 63-ФЗ от 31.05.2002) и Кодексом профессиональной этики адвоката....',
        href: '/article/how-to-choose-a-reliable-lawyer',
        img: '/static/img/show_art_all.png',
        isHide: false,
      },
      {
        title: 'Что такое безопасная сделка? Разбираем на примере.',
        text: 'В последнее время, в сферах торговли и оказания услуг популярность приобретает так называемая “безопасная сделка”. Что это такое  и чем она хороша?...',
        href: '/article/what-is-a-secure-transaction',
        img: '/static/img/show_art_all.png',
        isHide: false,
      },
      {
        title: 'Как строить работу с адвокатом, чтобы достичь максимального результата?',
        text: 'В этой статье мы расскажем как эффективно взаимодействовать с адвокатом, если у Вас возникла такая необходимость. О том, как выбрать подходящего адвоката и на что обратить внимание.... ',
        href: '/article/how-to-work-with-a-lawyer-to-achieve-maximum-results',
        img: '/static/img/show_art_all.png',
        isHide: false,
      },
      {
        title: 'Лжеюристы в России.',
        text: 'В последнее время в России появилось немало коммерческих организаций, которые позиционируют себя как профессиональные юристы, проводят агрессивную рекламную компанию, заманивают людей, у которых возникла юридическая проблема, и обещают 100-процентный результат. Получив деньги, эти лже-правоведы в лучшем случае ....',
         href: '/article/lzheyuristi-v-rossii',
        img: '/static/img/show_art_all.png',
        isHide: false,
      },
      {
        title: 'Что важно знать,  если вас вызвали на допрос к следователю.',
        text: 'Если вас приглашают для проведения допроса, не надо паниковать. Это процедура может коснуться каждого. Вот что нужно знать:...',
        href: '/article/what-is-important-to-know-if-you-were-summoned-for-interrogation-by-the-investigator',
        img: '/static/img/show_art_all.png',
        isHide: false,
      },
    ],
    nowArticle: 0,
    news:[
      {
        title: 'Как выбрать надежного адвоката?',
        text: 'Деятельность всех адвокатов строго регламентируется Федеральным законом «Об адвокатской деятельности и адвокатуре в Российской Федерации» (N 63-ФЗ от 31.05.2002) и Кодексом профессиональной этики адвоката....',
        href: '/article/how-to-choose-a-reliable-lawyer',
        img: '/static/img/uristimg2.jpg',
        isHide: false,
      },
      {
        title: 'Что такое безопасная сделка? Разбираем на примере.',
        text: 'В последнее время, в сферах торговли и оказания услуг популярность приобретает так называемая “безопасная сделка”. Что это такое  и чем она хороша?...',
        href: '/article/what-is-a-secure-transaction',
        img: '/static/img/imgleft2.svg',
        isHide: false,
      },
      {
        title: 'Как строить работу с адвокатом, чтобы достичь максимального результата?',
        text: 'В этой статье мы расскажем как эффективно взаимодействовать с адвокатом, если у Вас возникла такая необходимость. О том, как выбрать подходящего адвоката и на что обратить внимание.... ',
        href: '/article/how-to-work-with-a-lawyer-to-achieve-maximum-results',
        img: '/static/img/imgleft3.svg',
        isHide: false,
      },
      {
        title: 'Лжеюристы в России.',
        text: 'В последнее время в России появилось немало коммерческих организаций, которые позиционируют себя как профессиональные юристы, проводят агрессивную рекламную компанию, заманивают людей, у которых возникла юридическая проблема, и обещают 100-процентный результат. Получив деньги, эти лже-правоведы в лучшем случае ....',
        href: '/article/lzheyuristi-v-rossii',
        img: '/static/img/imgleft4.svg',
        isHide: false,
      },
      {
        title: 'Что важно знать,  если вас вызвали на допрос к следователю.',
        text: 'Если вас приглашают для проведения допроса, не надо паниковать. Это процедура может коснуться каждого. Вот что нужно знать:...',
        href: '/article/what-is-important-to-know-if-you-were-summoned-for-interrogation-by-the-investigator',
        img: '/static/img/imgleft.svg',
        isHide: false,
      },
    ],
    nowNews: 0,
    problem: null,
    special: null,
    regions: null,
    users:[],
    region: [],
    specializations: [],
    support: {
      name: null,
      email: null,
      text: null
    },
    questions: [
      {
        title: '"Мобильный адвокат" - это коллегия адвокатов?',
        id: 1,
        text: 'Нет, мы - сервис предоставляющий возможности клиенту быстро найти надежного адвоката, а адвокатам получать новых клиентов. На нашем портале зарегистрированы специалисты всех специализаций из разных городов и адвокатских палат'
      },
      {
        title: 'Сервис платный?',
        id: 2,
        text: 'Для клиентов сервис абсолютно бесплатен. Адвокаты платят небольшую комиссию с завершенной сделки'
      },
      {
        title: 'Как найти адвоката?',
        id: 3,
        text: 'Очень просто: на странице поиска укажите регион оказания услуг и специализацию. Сервис предложит Вам список адвокатов, подходящих под критерии поиска. Сначала идут адвокаты с наивысшим рейтингом. Выбирайте понравившегося адвоката и пишите ему. Кроме того, Вы также можете создать заявку в личном кабинете. В этом случае ее получат все адвокаты, подходящие под выбранные Вами критерии'
      },
      {
        title: 'Как я могу быть уверен в надежности выбранного исполнителя?',
        id: 4,
        text: 'Все адвокаты перед публикацией анкеты на портале проходят модерацию и предоставляют необходимые документы (паспорт и удостоверение адвоката). Наш сайт синхронизирован с порталом Министерства Юстиции РФ, где размещен реестр действующих адвокатов. Мы тщательно проверяем данные перед тем как одобрить анкету нового адвоката. Кроме того, всем нашим клиентам мы предоставляем услугу “Безопасная сделка” - гарант того, что адвокат получит деньги только после того как будут выполнены все договоренности'
      },
      {
        title: 'Что такое страхование адвоката?',
        id: 5,
        text: 'Адвокаты имеют возможность застраховать риск своей профессиональной ответственности через наш портал в аккредитованных страховых компаниях'
      },
      {
        title: 'Как работает "Безопасная сделка"?',
        id: 6,
        text: 'Когда Вы оплачиваете сделку, деньги поступают не на счет адвоката, а на специальный эскроу-счет, где хранятся до завершения сделки. Адвокат получит деньги лишь тогда, когда Вы подтвердите в личном кабинете, что специалист выполнил работу.'
      },
      {
        title: 'А что, если адвокат не выполнил работу?',
        id: 7,
        text: 'В этом случае Вы открываете спор в сделке. Она переходит к нашему модератору, который разбирается в подробностях. После модерации, средства возвращаются Вам обратно в полном объеме'
      },
      {
        title: 'Я не хочу, чтобы о моем деле знали еще кто-то кроме меня и адвоката. Как Вы обеспечиваете конфиденциальность?',
        id: 9,
        text: 'Не переживайте, мы позаботились о защите Ваших данных. Мы не передаем данные наших пользователей третьим лицам. Все сообщения и файлы хранятся на наших серверах в зашифрованном виде. Система построена таким образом, что подробности Вашего дела доступны лишь Вам и Вашему адвокату'
      },
      {
        title: 'Мне некогда выбирать адвоката. Мне он нужен прямо сейчас! Что я могу сделать?',
        id: 10,
        text: 'В этом случае воспользуйтесь услугой "Срочная помощь адвоката". В этом случае Вашу заявку получат специалисты, работающие в режиме 24/7 и оперативно на нее отреагируют'
      }
    ]
  }),

  mounted () {
    this.isDisabled = true;
    this.$axios
    .get("auth/registration/atribute")
    .then((res) => {
        this.specializations = res.data.result.specialization;
        this.region = res.data.result.region;
    })
    .finally(() => {
      this.isDisabled = false;
    });
    this.getAdv();
  },
  methods: {
    getAdv(){
      this.$axios.get("adv/top")
      .then((res)=>{
        console.log(res);
        this.adv = res.data.result.advList
      }).finally(()=>{

      })
    },
    toSearch(){
      this.$router.push({ path: `search`, force: true, query: {id: this.problem}});
    },
    toSearchTwoParametrs(){
      this.$router.push({ path: `search`, force: true, query: {id_spec: this.special, id_reg: this.regions}});
    },
    reg(){
      this.$root.$emit('modal.reg');
    },
    changeArticle(value){
      let index = this.article.findIndex(x => x.isHide);

      // this.article[index].isHide = false;

      // this.article[value].isHide = true;
      // console.log(this.article[value].isHide , index);
      this.nowArticle = value;
    },
    changeNews(value){
      let index = this.news.findIndex(x => x.isHide);

      // this.article[index].isHide = false;

      // this.article[value].isHide = true;
      // console.log(this.article[value].isHide , index);
      this.nowNews = value;
    },
    changeArticleMobile(value){
      let count = this.article.length;
      if(value == 1){
        if (count == this.nowArticle + 1) {
          this.nowArticle = 0;
        } else {
          this.nowArticle = this.nowArticle + 1;
        }
      } else {
        if (0 > this.nowArticle - 1) {
          this.nowArticle = count - 1;
        } else {
          this.nowArticle = this.nowArticle - 1;
        }
      }
    },
    sendSupport() {
      this.$axios.post(`support`, {
        name: this.support.name,
        email: this.support.email,
        text: this.support.text,
        phone: null,
        title: 'Запрос обратной связи',
        type: 'help',
      }).then(({data}) => {
        // if (data.cod == 200) {
        //   this.isComplite = true;
        // }
      })
    },
    changeNewsMobile(value){
      let count = this.news.length;
      if(value == 1){
        if (count == this.nowNews + 1){
          this.nowNews = 0;
        }else{
          this.nowNews = this.nowNews + 1;
        }
      }else{
        if (0 > this.nowNews - 1){
          this.nowNews = count - 1;
        }else{
          this.nowNews = this.nowNews - 1;
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getApi', 'getUser'])
  },
}



// WEBPACK FOOTER //
// ./src/pages/Home/home.js